<script>
  import { useNavigate } from 'svelte-navigator';
  import { onMount } from 'svelte';
  import Icon, { Save } from 'svelte-hero-icons';
  import Form from '../components/form/Form.svelte';
  import Validators from '../utils/validators';
  import { headerDisplayStore } from '../stores/General';
  import { create } from '../api';
  import { campaignAdEditStore } from '../stores/Campaign';
  import VastEditor from '../components/VastEditor.svelte';
  import Xonomy from '../libs/xonomy';
  import PlainInput from '../components/form/PlainInput.svelte';
  import InputWrapper from '../components/form/InputWrapper.svelte';

  const navigate = useNavigate();

  onMount(() => {
    headerDisplayStore.SetTitle('New Campaign Ad');
    headerDisplayStore.SetBreadCrumbs([
      {
        key: 'campaign',
        label: 'Campaign Ad',
      },
      {
        key: 'new',
        label: 'New',
      },
    ]);
  });

  let form;
  let rules = {
    name: {
      validators: [Validators.required],
    },
  };
  let xmlUrl = '';
  let initialXml = '';

  function onSubmit(e) {
    if (e?.detail?.valid) {
      e.detail.data.vast_xml = Xonomy.harvest();
      e.detail.data.vast_url = xmlUrl;
      e.detail.data.vast_original_xml = initialXml;
      create('campaign/ad', e.detail.data)
        .then((response) => {
          if (response?.status === 'ok') {
            headerDisplayStore.ShowNotification({
              title: 'Success',
              subtitle: 'Campaign Ad saved successfully',
            });
            navigate('/campaign');
          } else {
            headerDisplayStore.ShowError({
              title: 'Error',
              subtitle: response?.error,
            });
          }
        })
        .catch((error) => {
          headerDisplayStore.ShowError({
            title: 'Server error',
            subtitle: error?.message,
          });
        });
    } else {
      console.log('Invalid Form');
    }
  }
</script>

<div class="bg-white rounded">
  <div class="py-6">
    <div class="max-w-full mx-auto px-4 sm:px-6 md:px-8">
      <Form {rules} on:submit={onSubmit} bind:this={form}>
        <PlainInput name="campaign_id" type="hidden" value={$campaignAdEditStore?.campaign_id} />
        <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start  sm:pt-5">
          <InputWrapper label="Campaign Ad Id" required={true}>
            <PlainInput name="campaign_ad_id" />
          </InputWrapper>
        </div>
        <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start  sm:pt-5">
          <VastEditor
            label="VAST url or VAST XML"
            bind:url={xmlUrl}
            bind:initialXml
            isShowSaveButton={false}
          />
        </div>
        <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start  sm:pt-5">
          <div />
          <div>
            <span class="relative z-0 inline-flex shadow-sm rounded-md sm:shadow-none sm:space-x-3">
              <button
                type="submit"
                class="relative inline-flex items-center px-4 py-2 mr-6 rounded-md border border-gray-300 bg-yellow-500 text-sm font-medium text-yellow-800 hover:bg-yellow-400 focus:z-10 focus:outline-none focus:ring-1 focus:ring-blue-600 focus:border-blue-600"
              >
                <Icon src={Save} class="mr-2.5 h-5 w-5 text-white text-yellow-800" solid />
                <span>Save</span>
              </button>
              <button
                type="button"
                on:click={() => {
                  navigate('/campaign');
                }}
                class="hidden sm:inline-flex -ml-px relative items-center px-4 py-2 rounded-md border border-gray-300 bg-white text-sm font-medium text-gray-900 hover:bg-gray-50 focus:z-10 focus:outline-none focus:ring-1 focus:ring-blue-600 focus:border-blue-600"
              >
                <span>Cancel</span>
              </button>
            </span>
          </div>
        </div>
      </Form>
    </div>
  </div>
</div>
